module.exports = require("@swa-ui/application");